import axios from 'axios';
import util from 'util/baseUtil';

const user = function() {
  
  const CancelToken = axios.CancelToken;
  let source = CancelToken.source();


  /**
   * ajax 요청 취소
   */
  function cancelRequest() {
    source.cancel('cancel');
    source = CancelToken.source();
  }


  /**
   * 사용자 정보
   * @param {URLSearchParams} params 요청 파라미터 {userid: 사용자아이디}
   */
  async function get(params) {
    let response = await axios.post(`/api/user/get`, util.convertToURLParams(params), {cancelToken: source.token});
    return response.data;
  }


  return {
    cancelRequest: cancelRequest,
    get: get,
  }
}()


export default user;